// import React, { useRef } from 'react';
import React from 'react';
import Markdown from 'markdown-to-jsx';
import styles from './MarkdownRenderer.module.css';

export interface MarkdownRendererProps {
  content: string;
  className?: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, className }) => {
  // Strip inline citation markers like 【16:15†RI001.txt】
  const cleanContent = content.replace(/【[^】]*】/g, '');

  return (
    <div className={`${styles.markdown} ${className || ''}`} data-testid="markdown-render">
      <Markdown
        options={{
          forceBlock: true,
          overrides: {
            a: {
              component: (props: any) => (
                <a {...props} target="_blank" rel="noopener noreferrer" />
              ),
            },
          },
        }}
      >
        {cleanContent}
      </Markdown>
    </div>
  );
};